import React from 'react'
import { useTranslation } from 'react-i18next'
import { removePrefix, SUPPORTING_DOCUMENT_TYPE_CODE_PREFIX } from 'shared/ncts/common/classifier-util'
import TransitPreviewDocumentSection from './TransitPreviewDocumentSection'
import TransitPreviewField from './TransitPreviewField'
import { SupportingDocument } from '../../document/models/types'

interface TransitPreviewSupportingDocumentsProps {
  supportingDocuments: SupportingDocument[]
}

function TransitPreviewSupportingDocuments({
  supportingDocuments,
}: TransitPreviewSupportingDocumentsProps) {
  const { t } = useTranslation()

  if (!supportingDocuments?.length) return null

  return (
    <div className="card p-2">
      <h5 className="text-secondary mb-2">
        {
          t('declaration.p5.supportingDocuments')
        }
      </h5>
      {
        supportingDocuments.map((document) => (
          <TransitPreviewDocumentSection
            key={document.id}
            document={document}
            documentTypePrefix={SUPPORTING_DOCUMENT_TYPE_CODE_PREFIX}
          >
            <div className="col-12">
              <TransitPreviewField
                label={t('declaration.p5.supportingDocumentType')}
                value={removePrefix(document.documentType, SUPPORTING_DOCUMENT_TYPE_CODE_PREFIX) ?? ''}
              />
              <TransitPreviewField
                label={t('declaration.p5.supportingDocumentReferenceNumber')}
                value={document.referenceNumber ?? ''}
              />
              <TransitPreviewField
                label={t('declaration.p5.complementOfInformation')}
                value={document.complementOfInformation ?? ''}
              />
              <TransitPreviewField
                label={t('declaration.p5.itemNumber')}
                value={document.documentLineNumber !== null ? String(document.documentLineNumber) : ''}
              />
            </div>
          </TransitPreviewDocumentSection>
        ))
      }
    </div>
  )
}

export default TransitPreviewSupportingDocuments
